// :cow: Cosmose CONFIDENTIAL :iso:
export function getPrimaryDataset(label: string, values: number[]) {
  return {
    label,
    borderColor: '#00a2ff',
    borderWidth: 2,
    data: values,
    pointRadius: 0,
    pointHoverRadius: 5,
    fill: true,
    pointBackgroundColor: '#00a2ff',
    backgroundColor: 'transparent',
  };
}

export function getSecondaryDataset(label: string, values: number[]) {
  return {
    label: label,
    borderColor: '#00a2ff',
    borderWidth: 2,
    data: values,
    pointRadius: 0,
    pointHoverRadius: 5,
    fill: true,
    pointBackgroundColor: '#00a2ff',
    backgroundColor: 'rgba(0, 162, 255, 0.1)',
    borderDash: [2, 4],
  };
}

